<template lang="pug">
  .height-100
    transition(name="fade")
      editar-documento-importante(
        :id="idSeleccionado"
        v-if="mostrarModalEditar",
        @close="closeModalEditar",
        @closeRefresh="closeModalEditar(true)"
        @refresh="fetch"
        @changeId="changeId"
        :class="{'modal-sidebar-desktop-open': showSidebarDesktop }"
      )
    transition(name='fade-quick')
      .overlay-class(
        v-if="mostrarModalEmpleadosConDocumentos"
        :class="{'modal-sidebar-desktop-open': showSidebarDesktop }"
      )
        .card
          header.card-header
            p.card-header-title
              | ¿SEGURO QUE DESEA CONTINUAR?
          .card-content
            span {{ mensajeRespuesta }}
            .content
              ul
                li.tal(v-for="(nombre, index) in listaEmpleadosRespuesta" :key="index")
                  span {{ nombre }}
          footer.card-footer
            a.card-footer-item(
              @click="eliminarDocumento(true)"
            )
              span(v-if="isSaving") Guardando...
              span(v-else) Continuar
            a.card-footer-item(
              @click="cerrarModalEmpleadosConDocumentos()"
            ) Cancelar
    transition(
      name='fade',
      tag="div",
      v-if="mostrarConfirmacionEliminar"
      )
      confirmar-accion-overlay(
        @close="mostrarConfirmacionEliminar = false"
        @do="eliminarDocumento(false)"
        :class="{'modal-sidebar-desktop-open': showSidebarDesktop }"
        ref="confirmarEliminar"
      )
        span(slot="title") ¿Desea eliminar el documento {{ documentoSeleccionado.descripcion }}?
        span(slot="primaryAction")
          template(v-if="isSending")
            | Eliminando...
          template(v-else)
            | Eliminar
    transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
      .box.lista-solicitud-vacaciones.contenedor-interno(key="box-lista")
        .title
          span Gestion de documentos para firmar

        .message.is-info
          .message-body Los documentos cargados en esta pantalla, apareceran para todos los empleados activos de la plataforma

        .text-right
          button.button.is-small.margin-right-5.is-primary(@click="openModalEditar('')")
            span.icon.is-small
              i.fa.fa-plus
            span Nuevo
          button.button.is-small(@click="fetch")
            span.icon.is-small
              i.fa.fa-refresh
            span Refrescar

        .body
          .is-loading(v-if="isLoading")
            .icon
              i.fa.fa-spinner.fa-spin
          .information(v-else)
            table.table.is-striped.is-bordered(
              v-if="lista.length !== 0"
            )
              thead

                th Descripción
                th
              tbody(
                name="table-row"
                is="transition-group"
              )
                tr.row-table(
                  v-for="(o, index) in lista"
                  :key="index"
                  :class="{'is-close': !o.activo}"
                  @dblclick="openModalEditar(o.id)"
                )
                  td
                    .hint--top(:aria-label="'Orden: ' + o.orden")
                      span.hint--bottom(:aria-label="'ID: ' + o.id") {{ o.descripcion }}
                    .d-initial.mt-5
                      strong Modificado:&nbsp;
                      span {{ o.modificado }}
                  td.text-center
                    .td-wrapper
                      .contenedor-acciones
                        template(v-if="o.rutaSinLlenar")
                          a.button.is-small(:href="o.rutaSinLlenar", target="_blank")
                            span.icon.is-small
                              i.fa.fa-paperclip.is-small
                            span Ver adjunto
                        button.button.is-small.mt-10(@click="openModalEditar(o.id)")
                          span.icon.is-small
                            i.fa.fa-pencil-square-o
                          span Editar
                        button.button.is-small.is-danger(@click="confirmarEliminar(o)")
                          span.icon.is-small
                            i.fa.fa-times
                          span Eliminar
            div(v-else)
              .message.is-warning
                .message-body No hay documentos importantes ingresados
</template>

<script>
import EditarDocumentoImportante from '../components/c_documentos_firmar_editar'
import ConfirmarAccionOverlayComponent from '../components/Component_Confirmar_Accion_Overlay'

import { apiDelete, apiGet, notify } from '../util/general'
export default {
  name: 'gestion-documentos-importantes',
  data () {
    return {
      lista              : [],
      isLoading          : false,
      mostrarModalEditar : false,
      idSeleccionado     : null,
      mostrarConfirmacionEliminar: false,
      documentoSeleccionado: null,
      mostrarModalEmpleadosConDocumentos: false,
      mensajeRespuesta: '',
      listaEmpleadosRespuesta: [],
      isSaving: false
    }
  },
  computed : {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    }
  },
  components: {
    'editar-documento-importante': EditarDocumentoImportante,
    'confirmar-accion-overlay': ConfirmarAccionOverlayComponent
  },
  mounted () {
    this.fetch()
  },
  methods: {
    changeId (id) {
      this.idSeleccionado = id
    },
    fetch () {
      var vm = this
      vm.isLoading = true

      var obj = {
      }

      apiGet(vm, '/documentos-firmar/', obj, function (data) {
        vm.lista = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    openModalEditar (id) {
      var vm = this
      if (id) vm.idSeleccionado = id
      vm.mostrarModalEditar = true
    },
    closeModalEditar (refresh) {
      var vm = this
      vm.mostrarModalEditar = false
      vm.idSeleccionado = null
      if (refresh) vm.fetch()
    },
    confirmarEliminar (o) {
      var vm = this
      vm.documentoSeleccionado = {
        id: o.id,
        descripcion: o.descripcion
      }
      vm.mostrarConfirmacionEliminar = true
    },
    cerrarModalEmpleadosConDocumentos () {
      var vm = this
      vm.mostrarModalEmpleadosConDocumentos = false
      vm.mensajeRespuesta = ''
      vm.listaEmpleadosRespuesta = []
    },
    eliminarDocumento (eliminarForzado) {
      var vm = this
      var obj = {
        idDocumentoFirmar: vm.documentoSeleccionado.id
      }
      if (eliminarForzado) {
        obj.eliminarForzado = true
      } else {
        obj.eliminarForzado = false
      }
      apiDelete(vm, '/documentos-firmar', obj, function (data) {
        if (data.status === 2) {
          vm.mensajeRespuesta = data.message
          vm.listaEmpleadosRespuesta = data.lista
          vm.mostrarModalEmpleadosConDocumentos = true
          return
        }
        vm.mostrarModalEmpleadosConDocumentos = false
        notify(vm, 'success', 'Éxito', 'Documento eliminado correctamente')
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.mostrarConfirmacionEliminar = false
        apiGet(vm, '/documentos-firmar/sin-cargar', {}, function (data) {
          vm.$store.dispatch('setDocumentosPorFirmar', data.lista.length)
        })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .content
    max-height 180px
    overflow-y auto
  .contenedor-interno
    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    .title-filtro
      display flex
      text-align left
      padding-left 10px
      padding-bottom 10px
      margin-bottom 10px
      border-bottom 1px solid #ccc
      .text
        text-transform uppercase
        flex 1
      .caret
        cursor pointer

    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        max-width 25%
        .title-singular
          text-align left
          font-weight bold
          user-select: none
        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold

  .boton-container
    button
      margin-left 5px



  .is-loading
    margin-top 10px

  .information
    padding-top 10px

  th
    vertical-align: middle;
  td
    vertical-align: middle;

  td
    .email
      font-size 12px
      color #9a9a9a

  .table
    font-size 13px

  .td-status
    width: 50px;

  .status
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .circle
      width: 25px;
      height: 25px;
      border-radius: 50%
      transition background ease-in .15s
      border 1px solid #d8d8d8
      background-color #23d160
      &.green
        background-color #23d160
      &.yellow
        background-color #ffdd57
      &.red
        background-color #ff0000
      &.white
        background-color #ffffff

  .status-container-filtro
    display flex
    justify-content center
    align-items center
    .status
      margin 5px
      cursor pointer
      .circle
        transition all ease-in .15s
        width: 30px;
        height: 30px;
      &.selected
        .circle
          border 2px solid #565cde

  .contenedor-acciones
    display flex
    justify-content space-around
    .button
      flex 1
      margin 0px 5px

  .modal-sidebar-desktop-open
    width: calc(100% - 180px);

  @media (max-width: 820px)
    .modal-sidebar-desktop-open
      width: 100%;
  @media (max-width 450px)
    .table
      font-size 12px
      .td-wrapper
        display flex
        justify-content: center
        align-items: center
        flex-direction: column
        .contenedor-acciones
          flex-direction: column
          .button
            margin-bottom 5px
            &:last-child
              margin-bottom 0px

</style>




// WEBPACK FOOTER //
// View_Documentos_Firmar.vue?b033a5fc